"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeActionLogType = void 0;
exports.IkeActionLogType = {
    FIELD: 'field',
    CLI: 'cli',
    WEB: 'web'
};
//# sourceMappingURL=log.js.map